import React, { useState } from 'react';
import { CategoryScroller } from './CategoryScroller';
import { buttonStyles, groupCategoryButtonStyles } from '../../styles/commonStyles';
import { useNavigate, useLocation } from 'react-router-dom';

function ChannelCategoriesGroups({ groupedCategories, loading }) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const selectedCategoryId = params.get('category');

    function sortGroups(arr) {
        return [...arr].sort((a, b) => {
            if (a.group.position != null && b.group.position != null) return a.group.position - b.group.position;
            if (a.group.position != null) return -1;
            if (b.group.position != null) return 1;
            return a.group.id - b.group.id;
        });
    }
    const sortedGroups = sortGroups(groupedCategories?.groups || []);
    const ALL_GROUP = '__all__';
    const [activeGroup, setActiveGroup] = useState(ALL_GROUP);
    // Если группы изменились — сбрасываем выбранную группу на "Все"
    React.useEffect(() => {
        setActiveGroup(ALL_GROUP);
    }, [groupedCategories && groupedCategories.groups && groupedCategories.groups.map(g => g.group.id).join(",")]);

    if (loading) {
        return <div className="mb-4 text-gray-500">Загрузка категорий...</div>;
    }
    if (!groupedCategories || (groupedCategories.groups.length === 0 && groupedCategories.categories_without_group.length === 0)) {
        return null;
    }
    // Собираем все категории для "Все"
    const allCategories = [
        ...groupedCategories.groups.flatMap(g => g.categories),
        ...groupedCategories.categories_without_group
    ];
    // Функция для сортировки категорий по position, если есть, иначе по id
    function sortCategories(arr) {
        return [...arr].sort((a, b) => {
            if (a.position != null && b.position != null) return a.position - b.position;
            if (a.position != null) return -1;
            if (b.position != null) return 1;
            return a.id - b.id;
        });
    }
    // Если есть группы — показываем вкладки и скроллер внутри
    if (groupedCategories.groups.length > 0) {
        let categoriesToShow = [];
        if (activeGroup === ALL_GROUP) {
            // Сначала все группы по порядку, внутри — категории по порядку
            categoriesToShow = [];
            sortedGroups.forEach(({ group, categories }) => {
                categoriesToShow.push(...sortCategories(categories));
            });
            // В конце — категории без группы
            categoriesToShow.push(...sortCategories(groupedCategories.categories_without_group));
            categoriesToShow = categoriesToShow.slice(0, 20);
        } else {
            const group = groupedCategories.groups.find(g => g.group.id === activeGroup);
            categoriesToShow = group ? sortCategories(group.categories) : [];
        }
        // onSelect для категорий — меняет query-параметр
        const handleCategorySelect = (catId) => {
            const newParams = new URLSearchParams(location.search);
            if (catId) {
                newParams.set('category', catId);
            } else {
                newParams.delete('category');
            }
            navigate({ pathname: location.pathname, search: newParams.toString() }, { replace: true });
        };
        return (
            <div className="mb-4 w-full overflow-x-hidden">
                <div className="flex flex-row gap-2 overflow-x-auto whitespace-nowrap w-full">
                    <button
                        key={ALL_GROUP}
                        onClick={() => {
                            setActiveGroup(ALL_GROUP);
                            // Сбросить выбранную категорию в URL
                            const newParams = new URLSearchParams(location.search);
                            newParams.delete('category');
                            navigate({ pathname: location.pathname, search: newParams.toString() }, { replace: true });
                        }}
                        className={[
                            'flex-shrink-0',
                            groupCategoryButtonStyles,
                            activeGroup === ALL_GROUP
                                ? 'bg-blue-500 text-white dark:bg-blue-400 dark:text-white'
                                : ''
                        ].join(' ')}
                        style={{ userSelect: 'none' }}
                    >
                        Все
                    </button>
                    {sortedGroups.map(({ group }) => (
                        <button
                            key={group.id}
                            onClick={() => setActiveGroup(group.id)}
                            className={[
                                'flex-shrink-0',
                                groupCategoryButtonStyles,
                                group.id === activeGroup
                                    ? 'bg-blue-500 text-white dark:bg-blue-400 dark:text-white'
                                    : ''
                            ].join(' ')}
                            style={{ userSelect: 'none' }}
                        >
                            {group.name}
                        </button>
                    ))}
                </div>
                <CategoryScroller
                    categories={categoriesToShow.map(cat => ({ id: cat.id, name: cat.name }))}
                    value={selectedCategoryId ? Number(selectedCategoryId) : undefined}
                    onSelect={handleCategorySelect}
                />
                {groupedCategories.categories_without_group.length > 0 && (
                    <div className="mt-4">
                        <div className="font-semibold text-base text-gray-800 dark:text-gray-200">Без группы</div>
                        <CategoryScroller
                            categories={sortCategories(groupedCategories.categories_without_group).map(cat => ({ id: cat.id, name: cat.name }))}
                            value={selectedCategoryId ? Number(selectedCategoryId) : undefined}
                            onSelect={handleCategorySelect}
                        />
                    </div>
                )}
            </div>
        );
    }
    // Если групп нет — просто скролл по всем категориям
    return (
        <div className="mb-4 w-full overflow-x-hidden">
            <CategoryScroller
                categories={sortCategories(groupedCategories.categories_without_group).map(cat => ({ id: cat.id, name: cat.name }))}
                value={selectedCategoryId ? Number(selectedCategoryId) : undefined}
                onSelect={(catId) => {
                    const newParams = new URLSearchParams(location.search);
                    if (catId) {
                        newParams.set('category', catId);
                    } else {
                        newParams.delete('category');
                    }
                    navigate({ pathname: location.pathname, search: newParams.toString() }, { replace: true });
                }}
            />
        </div>
    );
}

export default ChannelCategoriesGroups; 